import { Button } from 'primereact/button';
import globalConfigStore from '../../../../../../stores/global-config-store';
import React, { useEffect, useState } from 'react';
import { AvailabilityResponse } from '../../../../../../api/types/calender/avalability-slots/availability-response';
import { getAvailabilitySlotsOperations } from './operations/get-availability-slots-operations';
import { Column, ColumnBodyOptions } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { AvailabilitySlot } from '../../../../../../api/types/calender/avalability-slots/availability-slot';
import { SelectedSlotsState } from './types/selected-slots';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { Tooltip } from 'primereact/tooltip';

interface TimeSlotContainerDataModel {
  branchId: number;
  startDate: Date | null;
  startTime: Date | null;
  endTime: Date | null;
  iterationNumber: number;
  selectedSlots: SelectedSlotsState;
  handleSlotSelect: (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => any;
  shouldInitiateSearchSlot: boolean;
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  };
}
export const TimeSlotContainer: React.FC<TimeSlotContainerDataModel> = ({
  branchId,
  startTime,
  startDate,
  endTime,
  iterationNumber,
  selectedSlots,
  handleSlotSelect,
  shouldInitiateSearchSlot,
  editTimeSlot,
}) => {
  const [availabilitySlots, setAvailabilitySlots] = useState<
    AvailabilityResponse[]
  >([]);

  const [isLoading, setIsLoading] = useState(false);

  const getVacationInfoForDate = (date: Date | null) => {
    if (!date) return null;

    const normalized = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0,
    );

    for (const v of globalSettingsStores.calendarVacations || []) {
      const start = v.startDate ? new Date(v.startDate as any) : null;
      const end = v.endDate ? new Date(v.endDate as any) : null;

      const startN = start
        ? new Date(start.getFullYear(), start.getMonth(), start.getDate())
        : null;
      const endN = end
        ? new Date(end.getFullYear(), end.getMonth(), end.getDate())
        : null;

      if (startN && endN) {
        if (normalized >= startN && normalized <= endN) {
          return { id: v.id, title: v.title };
        }
      } else if (startN) {
        if (normalized.getTime() === startN.getTime()) {
          return { id: v.id, title: v.title };
        }
      } else if (endN) {
        if (normalized.getTime() === endN.getTime()) {
          return { id: v.id, title: v.title };
        }
      }
    }

    return null;
  };

  const vacationInfoForScheduleDate = (() => {
    if (!startDate) return null;

    const normalized = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      0,
      0,
      0,
      0,
    );

    for (const v of globalSettingsStores.calendarVacations || []) {
      const start = v.startDate ? new Date(v.startDate as any) : null;
      const end = v.endDate ? new Date(v.endDate as any) : null;

      const startN = start
        ? new Date(start.getFullYear(), start.getMonth(), start.getDate())
        : null;
      const endN = end
        ? new Date(end.getFullYear(), end.getMonth(), end.getDate())
        : null;

      if (startN && endN) {
        if (normalized >= startN && normalized <= endN) {
          return { id: v.id, title: v.title };
        }
      } else if (startN) {
        if (normalized.getTime() === startN.getTime()) {
          return { id: v.id, title: v.title };
        }
      } else if (endN) {
        if (normalized.getTime() === endN.getTime()) {
          return { id: v.id, title: v.title };
        }
      }
    }

    return null;
  })();

  const vacationHeaderBadge = vacationInfoForScheduleDate ? (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        marginRight: '8px',
      }}
    >
      <span
        className="vacation-warning-icon"
        data-pr-tooltip={vacationInfoForScheduleDate.title}
        data-pr-position="top"
        title={vacationInfoForScheduleDate.title}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
      >
        <i
          className="pi pi-exclamation-triangle"
          style={{ color: '#f59e0b' }}
        />
        <span style={{ color: '#92400E', fontWeight: 700 }}>חופשה</span>
      </span>
    </span>
  ) : null;

  useEffect(() => {
    if (shouldInitiateSearchSlot) {
      handleSlotContainer();
    }
  }, [shouldInitiateSearchSlot]);

  const handleSlotContainer = async () => {
    const branchId2 =
      branchId || globalConfigStore.rootFilter.currentBranches.id;

    await getAvailabilitySlotsOperations(
      branchId2,
      startDate,
      startTime,
      endTime,
      iterationNumber,
      setIsLoading,
      setAvailabilitySlots,
      handleSlotSelect,
      editTimeSlot,
    );
  };

  return (
    <div>
      {/*<label>סדרת הרצאות</label>
      <Tag value={'Asd'} severity={'danger'} style={{ borderRadius: '50px' }} />

      <div>{availabilitySlots.length}</div>*/}

      <Button
        style={{ height: '36px' }}
        onClick={handleSlotContainer}
        severity="info"
        label={'לחץ בדיקת זמינות החדרים'}
        loading={isLoading}
      />

      <Tooltip target=".vacation-warning-icon" />

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={availabilitySlots?.[0]?.slots ?? []}
        scrollable
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="courseName"
          header={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>הרצאות</span>
                {vacationHeaderBadge}
              </div>
            </div>
          }
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(data: AvailabilitySlot, options: ColumnBodyOptions) => {
            const rowDate = data?.startTime
              ? new Date(data.startTime as any)
              : null;
            const dateLabel =
              rowDate && !Number.isNaN(rowDate.getTime())
                ? rowDate.toLocaleDateString('he-IL')
                : '';
            const vacationInfo = getVacationInfoForDate(rowDate);

            return (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>הרצאה {options.rowIndex + 1}</div>
                <div
                  style={{
                    marginTop: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '12px',
                    color: '#6b7280',
                  }}
                >
                  {dateLabel && <span>{dateLabel}</span>}
                  {vacationInfo && (
                    <span
                      className="vacation-warning-icon"
                      data-pr-tooltip={vacationInfo.title}
                      data-pr-position="top"
                      title={vacationInfo.title}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        color: '#92400E',
                        fontWeight: 700,
                      }}
                    >
                      <i
                        className="pi pi-exclamation-triangle"
                        style={{ color: '#f59e0b' }}
                      />
                      <span>חופשה</span>
                    </span>
                  )}
                </div>
              </div>
            );
          }}
        />
        {availabilitySlots.map((classItemSlots) => (
          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="courseName"
            header={
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{classItemSlots.className}</span>
                  {vacationHeaderBadge}
                </div>
              </div>
            }
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(data: AvailabilitySlot, options: ColumnBodyOptions) => (
              <div>
                <div>
                  {classItemSlots.slots[options.rowIndex].isAvailable ? (
                    <Button
                      style={{ height: '30px' }}
                      severity={
                        selectedSlots?.[options.rowIndex]?.some(
                          (item) => item.classId === classItemSlots.classId,
                        )
                          ? 'success'
                          : 'primary'
                      }
                      value={'asd'}
                      outlined={
                        !selectedSlots?.[options.rowIndex]?.some(
                          (item) => item.classId === classItemSlots.classId,
                        )
                      }
                      label="פנוי"
                      onClick={() =>
                        handleSlotSelect(options.rowIndex, {
                          classId: classItemSlots.classId,
                          startTime:
                            classItemSlots.slots[options.rowIndex].startTime,
                          endTime:
                            classItemSlots.slots[options.rowIndex].endTime,
                          isAvailable:
                            classItemSlots.slots[options.rowIndex].isAvailable,
                        })
                      }
                    />
                  ) : (
                    <Button
                      style={{ height: '30px' }}
                      severity={'secondary'}
                      value={'asd'}
                      label="תפוס"
                      disabled={true}
                    />
                  )}
                </div>
              </div>
            )}
          />
        ))}
      </DataTable>
    </div>
  );
};
